module.exports = __webpack_public_path__ + "static/media/unboxing_summer_3.659842af.jpg";